export function getRealIndex(targetIndex: number) {
	if (targetIndex <= 2) return 5 + targetIndex;
	if (targetIndex >= 8) return targetIndex - 5;
	return targetIndex;
}
